import Vue from 'vue';
export const EventBus = new Vue();  // use this for very simple messaging between components - e.g. opening User Verification Modal. For most things, we want to use Vuex.
export const ModalBus = new Vue();  // use this for modal events
